module.exports = __webpack_public_path__ + "img/image_processing20200330-7332-hqwaa9.7684980e.gif";